import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Card, CardBody, type TCardProps } from '@/src/elements/card'

export const ImportantSection = ({ children, classNames, ...otherProps }: TCardProps): ReactNode => (
  <Card
    radius="md"
    shadow="none"
    classNames={{
      ...classNames,
      base: clsx('bg-primary-bg-medium', classNames?.base),
      body: clsx('px-4 py-3', classNames?.body),
    }}
    {...otherProps}
  >
    <CardBody>{children}</CardBody>
  </Card>
)
